module.exports = __webpack_public_path__ + "media/images/icons/illustration/date-f4088378414c931fdd6054ee58ed73cd.svg";